const methods = ['error', 'log', 'warn'] as const;

const base =
  <T extends typeof methods[number]>(method: T) =>
  (...params: Parameters<typeof console[T]>) => {
    if (process.env.NODE_ENV !== 'production') {
      console[method]('[top-area]: ', ...params);
    }
  };

export const log = {
  info: base('log'),
  error: base('error'),
  warn: base('warn'),
};
